export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SolarPanels: 1,
    DavidsRib: 1,
    RemovableGangway: 1,
    MastAndBoom: 1,
    Wheel: 1,
    SprayHood: 1,
    BoomCover: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/exterior_view02.js